const ENMyBusinessGroup = {
	"Acesso à Gestão de riscos": "Access to Risk Management",
	"Acesso à Matriz BCG": "Access to the BCG Matrix",
	"Acesso à Matriz de Priorização": "Access to the Prioritization Matrix",
	"Acesso à Matriz RACI": "Access to the RACI Matrix",
	"Acesso ao BSC": "Access to the BSC",
	"Acesso ao Kanban": "Kanban Access",
	"Acesso ao OKR" : "OKR Access",
	"Acesso ao Orçamento Financeiro": "Access to the Financial Budget",
	"Acesso ao Plano de Ações": "Access to the Action Plan",
	"Acesso aos Cadastros básicos": "Access to Basic Records",
	"Acesso aos Diagnósticos do Negócio e Canvas": "Access to Business Diagnostics and Canvas",
	"Acesso aos Indicadores": "Access to Indicators",
	"Acesso aos Projetos": "Access to Projects", 
	"Acesso às Análises": "Access to Analytics",
	"Acesso às Auditorias": "Access to Audits",
	"Acesso às Estratégias": "Access to Strategies",
	"Acesso às FCAs": "Access to FCAs",
	"Acesso às Ocorrências": "Access to Occurrences",
	"Acesso às Reuniões": "Access to Meetings",
	"Alertas": "Alerts",
	"Análise SWOT": "SWOT Analysis",
	"API de Integração": "API Integration",
	"Espaço de armazenamento em gigabytes": "Storage space in gigabytes",
	"Número de empresas ativas cadastradas": "Number of active companies registered",
	"Número de usuários habilitados cadastrados": "Number of registered enabled users", 
	"sem registros": "no records",
	"Erro ao carregar dados": "Error loading data",
	"Meu grupo empresarial": "My business group"
};

export default ENMyBusinessGroup;




